import {DriveScoutLogin} from './vueLoginComponent';
import {DriveScout} from './drivescout';
window.drivescout = {
    LoginComponent: DriveScoutLogin,
    client: new DriveScout()
}
